import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'

interface Props {
  setFiles: (files: any) => void
  nextStep?: () => void
}

const SinglePhotoDropzone: React.FC<Props> = ({ setFiles, nextStep }) => {
  const dzStyles = {
    borderWidth: '2px',
    borderStyle: 'dashed',
    borderColor: '#000',
    borderRadius: '5px',
    backgroundColor: '#F4F0F0',
    paddingTop: '35px',
    textAlign: 'center' as const,
    height: 100,
    marginBottom: '20px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 5px 20px 0px rgba(0, 0, 0, 0.10)',
  }

  const dzActive = {
    borderColor: 'green',
  }

  const { t } = useTranslation()

  const onDrop = useCallback(
    (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file: any) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      )
      nextStep ? nextStep() : null
    },
    [setFiles],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <div {...getRootProps()} style={isDragActive ? { ...dzStyles, ...dzActive } : dzStyles}>
      <input {...getInputProps()} />
      <i className='fa-solid fa-upload me-2' />
      <p style={{ fontSize: '1rem' }}>{t('drop_zone.drop_here')}</p>
    </div>
  )
}

export default SinglePhotoDropzone
